/* @flow */
import GroupScheduledMessage from './GroupScheduledMessage';
import Messages from 'collections/Messages';
import * as React from 'react';
import cx from 'classnames';

import './styles/GroupScheduledMessageList.scss';

class GroupScheduledMessageList extends React.Component<{
  messages: Messages,
  className?: string,
  target?: *,
}> {
  render() {
    const { messages, className } = this.props;
    const messageList = messages
      .toArray()
      .sort((a, b) => a.getSendAt() - b.getSendAt())
      .map(message => (
        <GroupScheduledMessage
          className={cx({
            'GroupScheduledMessageList-item': true,
            'GroupScheduledMessageList-non-collapsible-item': true,
          })}
          key={message.get('uuid')}
          message={message}
          target={this.props.target}
        />
      ));

    return (
      <div
        className={cx(
          'GroupScheduledMessageList',
          'GroupScheduledMessageList-non-collapsible',
          className
        )}>
        <div key="messageList">{messageList}</div>
      </div>
    );
  }
}

export default GroupScheduledMessageList;
